// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__32Zwc","productName":"Table_productName__3qH2S"};